var _g, _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 46,
    viewBox: "0 0 41 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10364_31798)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.8619 3.20553C19.8742 2.61507 21.1258 2.61507 22.1381 3.20553L34.3871 10.3508C35.3859 10.9334 36 12.0027 36 13.1589V27.5078C36 28.664 35.3859 29.7332 34.3871 30.3158L22.1381 37.4611C21.1258 38.0516 19.8742 38.0516 18.8619 37.4611L6.61288 30.3158C5.61414 29.7332 5 28.664 5 27.5078V13.1589C5 12.0027 5.61414 10.9334 6.61288 10.3508L18.8619 3.20553Z",
    fill: "#3897F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.3428 2.85452C21.2041 2.19025 19.7959 2.19025 18.6572 2.85452L6.40813 9.99981C5.28454 10.6552 4.59363 11.8581 4.59363 13.1589V27.5078C4.59363 28.8085 5.28454 30.0114 6.40813 30.6669L18.6572 37.8121C19.7959 38.4764 21.2041 38.4764 22.3428 37.8121L34.5919 30.6669C35.7155 30.0114 36.4064 28.8085 36.4064 27.5078V13.1589C36.4064 11.8581 35.7155 10.6552 34.5919 9.9998L22.3428 2.85452Z",
    stroke: "url(#paint0_angular_10364_31798)",
    strokeWidth: 0.812734
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31519 29.4766L8.86803 31.185L10.6421 31.7173L8.86803 32.2497L8.31519 33.9581L7.76234 32.2497L5.98828 31.7173L7.76234 31.185L8.31519 29.4766Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.0762 15.485C29.5001 15.909 29.5001 16.5963 29.0762 17.0202L18.7202 27.3762L13.0679 21.7239C12.644 21.3 12.644 20.6127 13.0679 20.1888C13.4918 19.7649 14.1791 19.7649 14.603 20.1888L18.7202 24.306L27.5411 15.485C27.965 15.0611 28.6523 15.0611 29.0762 15.485Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.900378,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9337 5.90735L33.6393 8.08771L35.9035 8.76717L33.6393 9.44663L32.9337 11.627L32.2281 9.44663L29.9639 8.76717L32.2281 8.08771L32.9337 5.90735Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10364_31798",
    x: 0.123831,
    y: 0.73085,
    width: 40.7523,
    height: 44.8941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.84457
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.03183
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.620833 0 0 0 0 0.816599 0 0 0 0 1 0 0 0 0.38 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10364_31798"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10364_31798",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_angular_10364_31798",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.4419 20.5365) rotate(90) scale(19.0992 19.0992)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.250155,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.498102,
    stopColor: "#3897F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746925,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999846,
    stopColor: "#3897F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.6becdecd2897829eee74cbcd63b101c2.svg";
export { ForwardRef as ReactComponent };